// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"b5be0a9b","419":"929b78c3","425":"6a28f4c5","439":"6c901206","503":"71343dd4","557":"eb9efc80","739":"2988a917","765":"e7e0863d","774":"a4567436","787":"a99e75db","883":"bb484f47"}[chunkId] + ".chunk.js";
};